import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { Form, InputGroup } from "react-bootstrap";
import ClearIcon from "@material-ui/icons/Clear";
import SearchIcon from "@material-ui/icons/Search";
import * as Admin from "../store/ducks/admin.duck";
import { Grid, Paper, FormControl, InputLabel, Select, MenuItem, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
  formControl: {
    margin: 0, //theme.spacing(1),
    minWidth: 120,
  },
  formControlWide: {
    margin: 0, //theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    backgroundColor: "#fff",
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

export default function AuditLog(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const filters = useSelector((state) => state.admin.Filters);
  const auditLog = useSelector((state) => state.admin.AuditLog);
  useEffect(() => {
    dispatch(Admin.actions.fetchAuditLog({ clientID: props.clientID }));
  }, [dispatch]);

  const searchLog = (log) => {
    const query = filters.auditLogSearch?.trim().toLowerCase();
    const words = query ? query.split(" ").filter(Boolean) : [];

    const fields = [log.description, log.entity, log.createdBy].filter(Boolean).map((f) => f.toLowerCase());

    return (
      // Text search
      (words.length === 0 || words.every((word) => fields.some((field) => field.includes(word)))) &&
      // Area
      (filters.auditLogArea === "All" || !filters.auditLogArea || log.entity === filters.auditLogArea)
    );
  };

  const filteredAuditLog = auditLog.filter((log) => searchLog(log));

  const columns = [
    { field: "id", headerName: "ID", width: 100, hide: true },
    { field: "entity", headerName: "Area", width: 100 },
    { field: "description", headerName: "Action", width: 400 },
    { field: "createdOn", headerName: "TimeStamp", width: 150 },
    { field: "sortCreatedOn", headerName: "Created", type: "number", hide: true },
    { field: "createdBy", headerName: "User", width: 220 },
  ];

  return (
    <>
      <Paper>
        <Grid container style={{ padding: 10 }}>
          <Grid item style={{ paddingLeft: 2, paddingRight: 10 }}>
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                type="text"
                value={filters.auditLogSearch}
                onChange={(event) => dispatch(Admin.actions.setFilters({ filterName: "auditLogSearch", filterValue: event.target.value }))}
                autoComplete="OFF"
                style={{ maxWidth: 170, height: 35, backgroundColor: filters.clientsTerm.length > 0 ? "rgb(250 239 195)" : "white" }}
              />
              <InputGroup.Append onClick={() => dispatch(Admin.actions.setFilters({ filterName: "auditLogSearch", filterValue: "" }))}>
                <InputGroup.Text>
                  <ClearIcon fontSize="small" style={{ color: filters.clientsTerm.length > 0 ? "#222222" : "silver", marginLeft: -3 }} />
                </InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="area-label" className={classes.label}>
                Area
              </InputLabel>
              <Select
                labelId="area-label"
                id="area"
                margin="dense"
                style={{ minWidth: 120, backgroundColor: "#ffffff" }}
                value={filters.auditLogArea}
                onChange={(event) =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "auditLogArea",
                      filterValue: event.target.value,
                    }),
                  )
                }
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Client">Client</MenuItem>
                <MenuItem value="Booking">Booking</MenuItem>
                <MenuItem value="File">File</MenuItem>
                <MenuItem value="Score">Score</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>

      <Paper style={{ height: 700 }}>
        <DataGridPro
          rows={filteredAuditLog}
          columns={columns}
          checkboxSelection={false}
          rowHeight={40}
          sortModel={[{ field: "sortCreatedOn", sort: "desc" }]}
        />
      </Paper>
    </>
  );
}
